/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-gift.js
   asset: assets/skon-gift.js
   Modulo: Gift With Purchase (GWP) — decoratore UX della barra cart-drawer
   Versione: 1.3.0
   Aggiornato: 2026-06-30 15:30 CEST (Europe/Rome)

   COSA FA
   ───────
   Aggiunge un secondo goal (omaggio) alla barra free-shipping ESISTENTE, senza
   toccare skon-fs-test.js. Decoratore in sola lettura su 'skon-fs:state-changed'.
   La traccia misura i soldi verso la soglia omaggio; inietta un proprio fill e
   due marker (spedizione 🚚 al valore kit, omaggio 🎁 obiettivo in fondo),
   nascondendo via CSS fill/marker nativi. Vedi skon-gift.css per gli stili.

   ICONE (v1.2)
   ────────────
   Icone SVG a LINEA (stroke=currentColor): ereditano il colore dell'elemento,
   quindi sono grigie/outline quando "da raggiungere" (pill in stato disabled) e
   colorate quando "raggiunto". Niente emoji.

   STATO OMAGGIO: la pill passa a "Omaggio aggiunto" SOLO se il prodotto omaggio
   (quello scelto nel Customizer) è davvero in carrello — match server-side per
   product id in skon-gift-data.liquid, riserva JS per handle. L'aggiunta è
   gestita da Dealeasy.

   ── CHANGELOG ──────────────────────────────────────────────────────────
   v1.2.2 (2026-06-24): pill spedizione raggiunta usa chipShippingDone
                        ("Spedizione sbloccata"); caption raggiunto più incisive.
   v1.2.1 (2026-06-24): il marker spedizione compare per OGNI sblocco FS — al
                        valore kit se presente, altrimenti accanto al regalo
                        (subito prima) quando la spedizione si ottiene a €49.
                        Guardia headline contro "ti mancano €0".
   v1.2.0 (2026-06-24): icone SVG a linea iniettate (innerHTML); stato pending
                        disabled. API icone tramite costanti SVG_SHIP/SVG_GIFT.
   v1.1.0 (2026-06-24): fill+marker propri; marker spedizione al valore kit.
   v1.0.0 (2026-06-23): prima release.
══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var CFG = window.SKON_GIFT_CONFIG;
  if (!CFG || !CFG.enabled) return;

  var SHELL_SEL = '.skon-fs-progress[data-skon-fs-shell="1"]';

  /* Icone goal — SVG a linea, stroke=currentColor (colore ereditato). */
  var SVG_SHIP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 7h11v9H2z"/><path d="M13 10h4l3 3v3h-7z"/><circle cx="6.5" cy="18" r="1.6"/><circle cx="16.5" cy="18" r="1.6"/></svg>';
  var SVG_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4z"/><path d="M3.5 8h17v3h-17z"/><path d="M12 8v12"/><path d="M12 8C10.5 8 8.7 7.2 9.1 5.6 9.4 4.4 11 5 12 8z"/><path d="M12 8C13.5 8 15.3 7.2 14.9 5.6 14.6 4.4 13 5 12 8z"/></svg>';

  var _lastState = null;
  var _lastInCart = null;

  // ── Helper ────────────────────────────────────────────────────────────
  function _euro(cents) {
    var v = (cents || 0) / 100;
    if (Math.round(v) === v) return '€' + v.toFixed(0);
    return '€' + v.toFixed(2).replace('.', ',');
  }
  function _fmt(tpl, gapStr) { return String(tpl || '').replace('{gap}', gapStr); }
  function _ease(linearPct) {  // identico al core FS (√)
    if (linearPct <= 0) return 0;
    if (linearPct >= 100) return 100;
    return Math.sqrt(linearPct / 100) * 100;
  }
  function _probe() { return document.querySelector('[data-skon-gift-data]'); }

  function _giftInCart(fsState) {
    try {
      var p = _probe();
      if (p && p.getAttribute('data-skon-gift-in-cart') === '1') return true;
    } catch (e) {}
    try {
      var items = fsState && fsState.cart && fsState.cart.items;
      if (items && items.length) {
        var vids = CFG.productVariantIds || [], handles = CFG.productHandles || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i] || {};
          if (vids.indexOf(it.variant_id) !== -1) return true;
          if (it.handle && handles.indexOf(it.handle) !== -1) return true;
        }
      }
    } catch (e) {}
    return false;
  }

  function _kitValueCents() {
    try {
      var p = _probe();
      if (p) { var v = parseInt(p.getAttribute('data-skon-kit-value-cents') || '0', 10); return isNaN(v) ? 0 : v; }
    } catch (e) {}
    return 0;
  }

  function _computeGift(fsState) {
    var subtotal = fsState.subtotal_cents || 0;
    var fsThr    = fsState.threshold_cents || 0;
    var giftThr  = CFG.threshold;
    var inCart   = _giftInCart(fsState);
    return {
      fsAchieved:    !!fsState.achieved,
      inCart:        inCart,
      kitValueCents: _kitValueCents(),
      subtotal:      subtotal,
      fsGap:         Math.max(0, fsThr - subtotal),
      giftGap:       Math.max(0, giftThr - subtotal),
      complete:      inCart && !!fsState.achieved
    };
  }

  // ── Iniezione nodi (idempotente) ───────────────────────────────────────
  function _ensureNodes(shell) {
    var track = shell.querySelector('.skon-fs-progress-track');

    var headline = shell.querySelector('.skon-gift-headline');
    if (!headline) {
      headline = document.createElement('div');
      headline.className = 'skon-gift-headline';
      headline.setAttribute('data-skon-gift', '1');
      if (track && track.parentNode === shell) shell.insertBefore(headline, track);
      else shell.appendChild(headline);
    }

    var fill, mkShip, mkGift;
    if (track) {
      fill = track.querySelector('.skon-gift-fill');
      if (!fill) {
        fill = document.createElement('div');
        fill.className = 'skon-gift-fill';
        fill.setAttribute('data-skon-gift', '1');
        track.appendChild(fill);
      }
      mkShip = track.querySelector('.skon-gift-mk--ship');
      if (!mkShip) {
        mkShip = document.createElement('span');
        mkShip.className = 'skon-gift-mk skon-gift-mk--ship';
        mkShip.setAttribute('aria-hidden', 'true');
        mkShip.innerHTML = SVG_SHIP;
        mkShip.hidden = true;
        track.appendChild(mkShip);
      }
      mkGift = track.querySelector('.skon-gift-mk--gift');
      if (!mkGift) {
        mkGift = document.createElement('span');
        mkGift.className = 'skon-gift-mk skon-gift-mk--gift';
        mkGift.setAttribute('aria-hidden', 'true');
        mkGift.innerHTML = SVG_GIFT;
        track.appendChild(mkGift);
      }
    }

    var chips = shell.querySelector('.skon-gift-chips');
    if (!chips) {
      chips = document.createElement('div');
      chips.className = 'skon-gift-chips';
      chips.setAttribute('data-skon-gift', '1');
      chips.innerHTML =
        '<span class="skon-gift-chip skon-gift-chip--ship" data-state="pending">' +
          '<span class="skon-gift-chip-ic" aria-hidden="true">' + SVG_SHIP + '</span>' +
          '<span class="skon-gift-chip-lb"></span></span>' +
        '<span class="skon-gift-chip skon-gift-chip--gift" data-state="pending">' +
          '<span class="skon-gift-chip-ic" aria-hidden="true">' + SVG_GIFT + '</span>' +
          '<span class="skon-gift-chip-lb"></span></span>';
      shell.appendChild(chips);
    }
    return { headline: headline, fill: fill, mkShip: mkShip, mkGift: mkGift, chips: chips };
  }

  function _setChip(el, state, label) {
    if (!el) return;
    el.setAttribute('data-state', state);          // pending | done → colore via CSS
    var lb = el.querySelector('.skon-gift-chip-lb');
    if (lb) lb.textContent = label || '';
  }

  // ── Render ──────────────────────────────────────────────────────────────
  function _render(fsState) {
    if (!fsState) return;
    _lastState = fsState;

    var shell = document.querySelector(SHELL_SEL);
    document.body.classList.toggle('skon-gift-active', !!shell);
    if (!shell) return;

    var g = _computeGift(fsState);
    var n = _ensureNodes(shell);
    var c = CFG.copy || {};

    document.body.classList.toggle('skon-gift-achieved', g.inCart);
    document.body.classList.toggle('skon-gift-complete', g.complete);

    if (n.fill) {
      var linear = g.complete ? 100 : Math.min(100, (CFG.threshold > 0 ? g.subtotal / CFG.threshold * 100 : 0));
      n.fill.style.width = _ease(linear).toFixed(1) + '%';
    }

    if (n.mkShip) {
      if (g.fsAchieved) {
        if (g.kitValueCents > 0) {
          // Spedizione sbloccata da un KitFreeShip: marker al valore economico del kit.
          var kv = Math.min(g.kitValueCents, g.subtotal);
          n.mkShip.style.left = _ease(Math.min(100, (CFG.threshold > 0 ? kv / CFG.threshold * 100 : 0))).toFixed(1) + '%';
        } else {
          // Spedizione sbloccata a soglia (no kit): marker camion in fondo, subito prima del regalo.
          n.mkShip.style.left = 'calc(100% - 20px)';
        }
        n.mkShip.hidden = false;
      } else {
        n.mkShip.hidden = true;
      }
    }

    var tx;
    if (g.complete) tx = c.headlineComplete;
    else if (g.inCart && !g.fsAchieved) tx = _fmt(c.headlineGiftDoneShipPending, _euro(g.fsGap));
    else if (g.fsAchieved && !g.inCart) tx = g.giftGap > 0 ? _fmt(c.headlineShipDoneGiftPending, _euro(g.giftGap)) : c.headlineShipDoneOnly;
    else tx = _fmt(c.headlineBothPending, _euro(g.giftGap));
    if (n.headline) n.headline.textContent = tx || '';

    _setChip(n.chips.querySelector('.skon-gift-chip--ship'), g.fsAchieved ? 'done' : 'pending', g.fsAchieved ? (c.chipShippingDone || c.chipShipping) : c.chipShipping);
    _setChip(n.chips.querySelector('.skon-gift-chip--gift'), g.inCart ? 'done' : 'pending', g.inCart ? c.chipGiftAdded : c.chipGiftPending);

    _lastInCart = g.inCart;
  }

  // ── Boot ────────────────────────────────────────────────────────────────
  function _onState(e) { _render(e && e.detail); }
  document.addEventListener('skon-fs:state-changed', _onState);

  function _boot() {
    try {
      if (window.SkonFS && window.SkonFS.cart) {
        if (typeof window.SkonFS.cart._buildState === 'function') {
          try { _render(window.SkonFS.cart._buildState()); } catch (e) {}
        }
        if (typeof window.SkonFS.cart.refresh === 'function') window.SkonFS.cart.refresh();
      }
    } catch (e) {}

    try {
      var host = document.querySelector('cart-drawer-component') || document.body;
      var _moTimer = null;
      var mo = new MutationObserver(function () {
        if (_moTimer) clearTimeout(_moTimer);
        _moTimer = setTimeout(function () {
          var shell = document.querySelector(SHELL_SEL);
          if (!shell || !_lastState) return;
          // (1) la barra è stata rimpiazzata dal morph del tema → ri-inietta
          if (!shell.querySelector('.skon-gift-chips')) { _render(_lastState); return; }
          // (2) l'omaggio è stato aggiunto/rimosso (es. da Dealeasy) → aggiorna la
          //     chip. Confronto con _lastInCart per evitare loop auto-indotti.
          if (_giftInCart(_lastState) !== _lastInCart) _render(_lastState);
        }, 120);
      });
      mo.observe(host, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _boot);
  else _boot();

  window.SkonGift = {
    version: '1.2.2',
    render: _render,
    getState: function () { return _lastState ? _computeGift(_lastState) : null; }
  };

})();